// extracted by mini-css-extract-plugin
export var btn = "PlusWelcome-module__btn___FPlUG";
export var content = "PlusWelcome-module__content___ohTTr";
export var desktopBadge = "PlusWelcome-module__desktopBadge___Wzw_k";
export var img = "PlusWelcome-module__img___kO0D3";
export var mobileBadge = "PlusWelcome-module__mobileBadge___UQfqa";
export var welcome = "PlusWelcome-module__welcome___lKo9r";